import React from 'react';
import './modal.css';

const Modal = ({ modalPhoto, openModal, closeModal, plusSlides, hasPrev, hasNext }) => {

  if (!openModal || !modalPhoto) {
    return null; // Prevent rendering unless the modal should be open
  }

  return (
    <div id="lightbox-container" className={openModal ? 'active' : ''}> {/* Apply active class conditionally */}
      <div className="lightbox-content">
        <div className="modal-content">
          <div className="mainSlide">
            <img 
              id='modal-image' 
              className='modal-image'
              key={modalPhoto.id}
              src={modalPhoto.url + '-large.jpg'}
              srcSet={`
                ${modalPhoto.url}-small.jpg 300w,
                ${modalPhoto.url}-medium.jpg 600w,
                ${modalPhoto.url}-large.jpg 1200w
              `}
              sizes="100vw"
              alt={modalPhoto.title}
            />
          </div>
          {/* Next/previous controls */}
          <span className="close cursor" onClick={closeModal}>&times;</span>
          <div className='prevnextcontainer'>
            <p id='prev' className={`prev ${hasPrev ? 'show' : ''}`} onClick={() => plusSlides(-1)}>&#10094;</p>
            <p id='next' className={`next ${hasNext ? 'show' : ''}`} onClick={() => plusSlides(1)}>&#10095;</p>
          </div>
        </div>
        <div className="caption-container">
          <p id="caption">{modalPhoto.title}</p>
        </div>
      </div>
    </div>
  );
}

export default Modal;